interface PathsInterface {
  dashboard: string;
  help: string;
  login: string;
  rebooting: string;
  rebootingUpgrade: string;
  security: string;
  settings: string;
  streaming: string;
  stats: string;
  statsfull: string;
  test: string;
}

export const Paths: PathsInterface = {
  dashboard: '/',
  help: '/help',
  login: '/login',
  rebooting: '/rebooting',
  rebootingUpgrade: '/rebooting-upgrade',
  security: '/security/:page?',
  settings: '/settings/:page?',
  streaming: '/streaming/:page?',
  stats: '/streaming/:page/stats/:id',
  statsfull: '/streaming/:page/stats-full/:id',
  test: '/test/*',
};

export const defaultRoute = '/';
